import { config } from '@/config';
import { SaveBar } from '@shopify/app-bridge-react';
import { useEffect } from 'react';

interface EmbeddedSaveBarProps {
  open: boolean;
  loading?: boolean;
  disabled?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  disableDiscard?: boolean;
}

const EmbeddedSaveBar = ({ open, loading, disabled, onSave, onDiscard, disableDiscard }: EmbeddedSaveBarProps) => {
  useEffect(() => {
    if (!open) {
      shopify.saveBar.hide(config.shopifySaveBarId);
    } else {
      shopify.saveBar.show(config.shopifySaveBarId);
    }
  }, [open]);

  return (
    <SaveBar id={config.shopifySaveBarId}>
      <button type="button" variant="primary" onClick={onSave} loading={loading ? '' : false} disabled={disabled || loading} />
      <button type="button" onClick={onDiscard} disabled={disableDiscard} />
    </SaveBar>
  );
};

export default EmbeddedSaveBar;
